import React, { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router'
import { Alert, Button, Stack, FormControl, Input, Textarea } from '@/components/lib'
import api from '../../../api'
import utils from '@/utils/utils'
import useStore from '../../../store'

// A blank trial: just a name and a description, everything else set up later.
export default function FromScratch ({ onCreated }) {
  const [name, setName] = useState('')
  const [description, setDescription] = useState('')
  const [error, setError] = useState()
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const { search } = useLocation()
  const { user } = useStore()

  useEffect(() => {
    if (search) {
      const params = new URLSearchParams(search)
      const name = params.get('name')
      if (name) setName(name)
    }
  }, [search])

  function createTrial () {
    setError()
    setLoading(true)
    api.teams.createTrial(user.team, { name, description }, trial => {
      onCreated(trial)
      setLoading(false)
      utils.toast('success', 'Trial created successfully')
    }, err => {
      setError(err.message)
      setLoading(false)
    })
  }

  return (
    <Stack gap={5}>
      <FormControl label='Trial name'>
        <Input autoFocus value={name} onChange={e => setName(e.target.value)} placeholder='Intervention or trial name' />
      </FormControl>

      <FormControl label='Trial description'>
        <Textarea value={description} onChange={e => setDescription(e.target.value)} placeholder='This trial aims to...' />
      </FormControl>
      <Alert variant='left-accent' status='info'>Please note that this information can be changed at any time.</Alert>

      {error &&
        <Alert variant='left-accent' status='error'>There was a problem creating your trial: {error}</Alert>}

      <Stack direction='row' justifyContent='end' alignItems='center'>
        <Button variant='ghost' onClick={() => navigate('/trials')}>Cancel</Button>
        <Button isLoading={loading} colorPalette='primary' onClick={createTrial}>Create trial</Button>
      </Stack>
    </Stack>
  )
}
